<template lang="pug">
//- for mobile view
second-menu(:selectorid="'tab-selector-year'",
            :tabs="tabs",
            :synctab.sync="tab",
            :isshadow="false")
.container
  #year-selector-dropdown.row
    .col-xs-12
      .menus.dropdown
        #dLabel(type='button', data-toggle='dropdown', aria-haspopup='true', aria-expanded='false')
          h4 {{tab}} &#62;
        ul.dropdown-menu(aria-labelledby='dLabel')
          li(v-for="tab in tabs" @click='changeTab(tab)')
            a {{tab.title}}
  .row
    .col-xs-12
      table.table
        thead
          tr.hidden-xs
            th {{'DATE' | wordDict}}
            th {{'TITLE' | wordDict}}

        tbody
          tr(v-for="row in rows")
            td.date.hidden-xs {{row.date | moment 'D MMMM YYYY'}}
            td
              div
                a.title(':href'="row.link", target="_blank") {{row.title | multilang}}
              div.visible-xs.date {{row.date | moment 'D MMMM YYYY'}}
</template>

<script>
import FilterList from './filter-list.vue'
import axios from 'axios'
import SecondMenu from './second-menu.vue'

export default {
  data () {
    return {
      data:{},
      rows: [],
      tab: '',
      tabs: [],
      selectingYear: false,
    }
  },
  props: {
    tabs_url: {
      type: String,
      required: true,
    },
    url: {
      type: String,
      required: true
    }
  },
  created () {
    axios.get(this.tabs_url)
      .then((response) => {
        const data = response.data
        let tabs = []
        for(var i in data.results)
          tabs.push( {title: data.results[i], id: data.results[i]} )
        this.tabs = tabs
        this.tab = this.tabs[0].id
      })
      .catch((err) => console.log(err))

  },
  ready () {},
  watch: {
    tab(val) {
      axios.get(this.url, {
          params: {
            year: val
          }
        })
        .then((response) => {
          const data = response.data
          this.rows = response.data.results
        })
    }
  },
  methods: {
    changeTab(val) {
      this.tab = val.id
    },
    selectingYearToggle() {
      this.selectingYear = this.selectingYear ? false : true;
    },
  },
  components: {
    'filter-list': FilterList,
    SecondMenu
  }
}
</script>

<style lang="scss" scoped>
@import "global";

.menus {
  h4 {
    font-size: 20px;
  }
  margin-bottom: 20px;
}
.table thead tr th {
  padding-top: 0;
}
.title {
  color: #6a859c;
}
.table tbody {
  tr {
    &:first-child {
      td {
        border-top: none;
      }
    }
    td {
      @media(max-width: #{$screen-xs-max}) {
        padding-top: 16px;
        padding-bottom: 16px;
        font-size: 14px;
      }
      font-size: 16px;
      &:first-child {
        width: 195px;
      }
      a {
        line-height: 24px;
        @media(max-width: #{$screen-xs-max}) {
          line-height: 1.5;
        }
      }
      .date {
        @media(max-width: #{$screen-xs-max}) {
          margin-top: 4px;
        }
      }
    }
  }
}
#tab-selector-year {
  display: none;
}
.container {
  @media(max-width: #{$screen-xs-max}) {
    margin-top: 0;
  }
}
</style>



// WEBPACK FOOTER //
// filter-table.vue?c23c0fb4